import { FirebaseEnvironmentName } from '../FirebaseConfig'
import React from 'react'

import './EnvironmentHeader.scss'

export const EnvironmentHeader = () => {
  if (process.env.REACT_APP_ENVIRONMENT_BANNER) {
    return (
      <div className="EnvironmentHeader">{process.env.REACT_APP_ENVIRONMENT_BANNER}</div>
    )
  }

  if (process.env.NODE_ENV === 'development' && FirebaseEnvironmentName !== 'production') {
    return (
      <div className="EnvironmentHeader">{FirebaseEnvironmentName}</div>
    )
  }

  return null
}